import { Text } from '@eo-locale/react';
import type { FC } from 'react';
import { useQuery } from 'react-query';
import { HistoryApi } from '../api';
import { InnerPageSection, InnerPageTitle, Table } from '../components';

export const DistinctionsPage: FC = () => {
  const { data } = useQuery('user-history', HistoryApi.fetch);

  return (
    <>
      {data?.distinctions.data.map((distinction, index) => (
        <InnerPageSection key={index}>
          <InnerPageTitle>
            <Text id="distinctions:title" />
          </InnerPageTitle>
          <Table>
            <thead>
              <tr>
                <th>
                  <Text id="distinctions:name" />
                </th>
                <th>
                  <Text id="distinctions:date" />
                </th>
                <th>
                  <Text id="distinctions:id" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{distinction.name}</td>
                <td>{distinction.date}</td>
                <td>{distinction.identification_number}</td>
              </tr>
            </tbody>
          </Table>
        </InnerPageSection>
      ))}
    </>
  );
};
